import ApiError from './api-error'

export const VALIDATION_ERROR_NAME = 'ValidationError'

export default class ValidationError extends ApiError {
  constructor (errors = [], originalError) {
    super(originalError)

    this.name = VALIDATION_ERROR_NAME

    // Custom debugging information
    this.errors = errors
  }
}



// WEBPACK FOOTER //
// ./src/order-api/error/validation-error.js